const newPassword = {
    senha: null,
    confirmarSenha: null,
};

export default newPassword;
